import type { AppRuntime } from '@ayocore/platform/client/runtime/AppRuntime';
import { IconMail } from '@tabler/icons-react';
import { lazy } from 'react';
import { isAdmin } from '@ayocore/platform/identity/client/guards';

/**
 * Бутстрап модуля Mailer (клиент)
 * Регистрирует навигацию через рантайм.
 */
export async function setup(app: AppRuntime) {
  const mailer = app.useModule('mailer', {
    version: '1.0.0',
    description: 'Email management and IMAP fetcher',
  });

  mailer.useNavigation([
    {
      icon: IconMail,
      label: 'Почта',
      url: '/mailer',
      component: lazy(() => import('./components/IncomingEmailsList')),
    },
    // Настройка почтовых аккаунтов — административный раздел, «Почта» выше доступна всем
    {
      icon: IconMail,
      label: 'Почтовые аккаунты',
      url: '/mailer/accounts',
      component: lazy(() => import('./components/EmailAccountsList')),
      guard: isAdmin,
    },
  ]);
}
